import http from '../internal/axios';
export var getBronzeCheck = function getBronzeCheck() {
  return http.get('/online_test/check').then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var sendBronzeEntry = function sendBronzeEntry(request) {
  return http.post('/online_test', request).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return true;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var getBronzePayment = function getBronzePayment(_ref) {
  var entry_id = _ref.entry_id,
      signature = _ref.signature,
      key = _ref.key,
      expire = _ref.expire,
      additional = _ref.additional;
  return http.post("/online_test/payment/create", {
    entry_id: entry_id,
    signature: signature,
    key: key,
    expire: expire,
    additional: additional
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};